/**
 * CartProvider constants
 */

export const CART_CHECK_AND_CONTINUE =
  'local/CartProvider/CART_CHECK_AND_CONTINUE';
export const CART_CHECK_AND_CONTINUE_COMPLETE =
  'local/CartProvider/CART_CHECK_AND_CONTINUE_COMPLETE';
export const CART_DELETE_ITEM_REQUEST =
  'local/CartProvider/CART_DELETE_ITEM_REQUEST';
export const CART_UPDATE_REWARDS_REQUEST =
  'local/CartProvider/CART_UPDATE_REWARDS_REQUEST';
